import { render, staticRenderFns } from "./EditarDadoModal.vue?vue&type=template&id=4cc5ddde&scoped=true"
import script from "./EditarDadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarDadoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditarDadoModal.vue?vue&type=style&index=0&id=4cc5ddde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5ddde",
  null
  
)

export default component.exports